import React from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router-dom'

// components
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import UnsubmittedReportPanel from './tab-panels/UnsubmittedReportPanel'

// icon
import { ChevronRight } from '@mui/icons-material'
import PendingApproverReportPanel from './tab-panels/PendingApproverReportPanel'
import CompletedReportPanel from './tab-panels/CompletedReportPanel'

const DashboardClaimTabs = () => {
  const navigate = useNavigate()
  const handleNavigate = () => {
    navigate(`reports`, {
      state: { fromDashboard: true },
    })
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        boxSizing="border-box"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography color="dark-text.main" variant="body1" fontWeight="bold" noWrap>
          My Claim Reports
        </Typography>
        <Box display="flex" alignItems="center" sx={{ cursor: 'pointer' }} onClick={handleNavigate}>
          <Typography
            variant="body1"
            color="alternate.main"
            noWrap
            display={{ xs: 'none', lg: 'block' }}
          >
            View All
          </Typography>
          <ChevronRight color="alternate" />
        </Box>
      </Box>
      <Box
        sx={{
          border: 1,
          borderRadius: '4.5px',
          borderColor: 'gray-line.main',
          bgcolor: 'white.main',
          maxHeight: 'calc(100vh - 267px)',
        }}
      >
        <AdxTabsBadge scrollButtons={false}>
          <AdxTabsPanel label="Draft" notification={null}>
            <UnsubmittedReportPanel />
          </AdxTabsPanel>
          <AdxTabsPanel label="Awaiting Approval" notification={null}>
            <PendingApproverReportPanel />
          </AdxTabsPanel>
          <AdxTabsPanel label="Approved" notification={null}>
            <CompletedReportPanel />
          </AdxTabsPanel>
        </AdxTabsBadge>
      </Box>
    </Box>
  )
}

export default DashboardClaimTabs
